import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import {
  CustomIconCta,
  CustomText,
  CustomTextInput,
  FallBack,
  Image,
  PrimaryCta,
  Video,
  ViewCards,
} from "../../components";
import Core from "../../common/clientSdk";
import UploadImageS3 from "../../common/s3";
import { useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Loader } from "../loader";
import { useSnackbar } from "react-simple-snackbar";
import { MessageBox, Input, Button, MessageList } from "react-chat-elements";
import { format, fromUnixTime } from "date-fns";
import "react-chat-elements/dist/main.css";
import SideMenu from "../sideMenu";
import Header from "../header";
import Utils from "../../common/utils";
import Icon from "../../components/core_component/icon";
import { ToastContainer, toast } from "react-toastify";
import { database } from "../../common/firebase";
import { ref, onValue, off, get } from "firebase/database";

let limit = 10;
function MessagesScreen(props) {
  // Media upload state and handlers
  const [uploading, setUploading] = useState(false);
  const [mediaId, setMediaId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // Store selected file for preview
  const [showPreviewLarge, setShowPreviewLarge] = useState(false); // For hover preview
  const fileInputRef = useRef(null);
  const uploadingRef = useRef(false); // Prevent duplicate uploads
  // Main chat state
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [assignmentList, setAssignmentList] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [influencerData, setInfluencerData] = useState({});
  const [assignmentDetail, setAssignmentDetail] = useState({});
  const [messageLoader, setMessagesLoader] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [influencerDetail, setInfluencerDetail] = useState({});
  const [influencerContactData, setInfluencerContactData] = useState({});
  const [contactModalIsOpen, setContactModalIsOpen] = useState(false);
  const [isLoadingContact, setLoadingContact] = useState(false);
  const [contactRequest, setContactRequest] = useState(true);
  const [isHover, setIsHover] = useState(false);
  const [metaData, setMetaData] = useState({});
  const [url, setUrl] = useState("");
  const [allMetaData, setAllMetaData] = useState({}); // Store metadata for all assignments
  const [loadingContentAction, setLoadingContentAction] = useState({}); // Track loading state for content actions
  const [openSnackbar] = useSnackbar();
  const inputRef = useRef(null);
  const chatContainerRef = useRef(null);
  const messagesEndRef = useRef(null); // Ref for the bottom of the messages list
  const currentAssignmentIdRef = useRef(null); // Track current active assignment ID
  const hasLoadedInitialAssignment = useRef(false); // Track if initial assignment was loaded
  const lastUpdateMetaDataCall = useRef({}); // Track last updateMetaData call time per assignment

  const navigate = useNavigate();

  const location = useLocation();
  const { campaignId } = location.state || {};

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    // Prevent duplicate uploads
    if (uploadingRef.current || uploading) {
      console.log("Upload already in progress, skipping...");
      return;
    }

    // Set both flag and state immediately to prevent duplicates
    uploadingRef.current = true;
    setUploading(true);

    // Store file for preview
    setSelectedFile(file);

    // Upload the file
    generateUploadUrl(file);
  }
  function openFilePicker() {
    if (fileInputRef.current) fileInputRef.current.click();
  }
  function removeSelectedFile() {
    setSelectedFile(null);
    setMediaId(null);
    setUploading(false);
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }
  function generateUploadUrl(uploadedFileObject) {
    console.log("influencerData", influencerData);
    var params = {
      action: "sample_content",
      id: influencerData.brand_id,
      file_type: uploadedFileObject.type,
    };
    // uploading state already set in handleFileChange
    Core.getGenerateUploadUrl(
      (response) => generateUrlSuccess(response, uploadedFileObject),
      generateUrlFailed,
      () => {},
      params
    );
  }
  function generateUrlSuccess(response, uploadedFileObject) {
    if (response) {
      UploadImageS3(uploadedFileObject, response?.upload_data, (error) => {
        setUploading(false);
        uploadingRef.current = false; // Reset upload flag
        if (error) {
          return toast.error("Upload failed");
        }
        // Use message_media_id for sending in message param
        setMediaId(response?.upload_data?.media_id);
        // toast.success("Upload successful");
      });
    } else {
      setUploading(false);
      uploadingRef.current = false; // Reset upload flag
      toast.error("Something went wrong");
    }
  }
  function generateUrlFailed(error) {
    setUploading(false);
    uploadingRef.current = false; // Reset upload flag
    toast.error(error || "Failed to get upload URL");
  }

  // Add effect to log when current assignment changes
  useEffect(() => {
    if (currentAssignmentIdRef.current) {
      updateMetaData(currentAssignmentIdRef.current, true);
    }
  }, [currentAssignmentIdRef.current]);
  const assignmentId = useParams()?.id;

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getAssignmentBrandDetails();
  }, []);

  useEffect(() => {
    if (assignmentList[0] && !assignmentId) {
      const item = assignmentList[0];
      getInfluencerDetailPublic(item.influencer_data.influencer_id);
      setAssignmentDetail({
        assignment_status: item.assignment_data.assignment_status,
      });
      const firstAssignmentId = item.assignment_data?.assignment_id;
      setInfluencerData({
        name: item.brand_data.name,
        influencer_name: item?.influencer_data?.name,
        // org_id_id: item.brand_data.org_id,
        influencer_id: item.influencer_data.influencer_id,
        // profile_picture: item.brand_data.image_id,
        influencer_profile_picture: item.influencer_data.profile_picture,
        assignment_id: firstAssignmentId,
        brand_id: item?.brand_data?.brand_id,
      });
    }
  }, [assignmentList, assignmentId]);

  console.log("influencerData.assignment_id", assignmentList);

  // Firebase listener for messages
  useEffect(() => {
    if (!influencerData.assignment_id) return;

    // Clear messages immediately when assignment changes to prevent showing stale data
    setMessages([]);

    // Update the current assignment ID ref
    currentAssignmentIdRef.current = influencerData.assignment_id;

    setMessagesLoader(true);
    let lastMessageId = null; // Track the last message ID instead of count
    let isInitialLoad = true; // Track if this is the first data load
    const currentAssignmentId = influencerData.assignment_id; // Capture the assignment_id for this listener
    const listenerId = `Listener-${Date.now()}`; // Unique ID for this listener instance

    // Use 'get' to fetch initial data once, then 'onValue' for real-time updates
    const messagesRef = ref(
      database,
      `chat/${influencerData.assignment_id}/messages`
    );

    console.log("Firebase messages", messages);

    // Real-time listener
    const unsubscribe = onValue(
      messagesRef,
      (snapshot) => {
        if (currentAssignmentId !== currentAssignmentIdRef.current) {
          return;
        }

        if (snapshot.exists()) {
          const messagesData = snapshot.val();
          const messagesArray = Object.keys(messagesData).map((key) => ({
            ...messagesData[key],
            message_id: messagesData[key].message_id || key,
          }));

          const sortedMessages = messagesArray.sort(
            (a, b) => (Number(a.created_at) || 0) - (Number(b.created_at) || 0)
          );

          // Get the latest message ID
          const latestMessageId =
            sortedMessages.length > 0
              ? sortedMessages[sortedMessages.length - 1].message_id
              : null;

          setMessages(sortedMessages);
          console.log("Updated messages from Firebase:", sortedMessages);

          if (
            !isInitialLoad &&
            latestMessageId !== lastMessageId &&
            latestMessageId !== null &&
            currentAssignmentId === currentAssignmentIdRef.current
          ) {
            updateMetaData(currentAssignmentId);
          }

          // Update tracking variables
          lastMessageId = latestMessageId;
          isInitialLoad = false;
        } else {
          setMessages([]);
          lastMessageId = null;
        }
        setMessagesLoader(false);
      },
      (error) => {
        setMessagesLoader(false);
      }
    );

    return () => {
      // Clean up the listener when the component unmounts or assignment_id changes
      off(messagesRef, unsubscribe);
    };
  }, [influencerData.assignment_id]);

  // Firebase listener for metadata
  useEffect(() => {
    if (!influencerData.assignment_id) return;

    const metaDataRef = ref(
      database,
      `chat/${influencerData.assignment_id}/meta_data`
    );

    const unsubscribe = onValue(
      metaDataRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const metaDataValue = snapshot.val();
          setMetaData(metaDataValue);
        } else {
          setMetaData({});
        }
      },
      (error) => {
        console.error("Firebase metadata listener error:", error);
      }
    );

    return () => {
      off(metaDataRef, unsubscribe);
    };
  }, [influencerData.assignment_id]);

  // Firebase listener for all assignments metadata
  useEffect(() => {
    if (!assignmentList || assignmentList.length === 0) return;

    const unsubscribes = [];

    assignmentList.forEach((item) => {
      const assignmentId = item.assignment_data?.assignment_id;
      if (!assignmentId) return;

      const metaDataRef = ref(database, `chat/${assignmentId}/meta_data`);

      const unsubscribe = onValue(
        metaDataRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const metaDataValue = snapshot.val();
            setAllMetaData((prev) => ({
              ...prev,
              [assignmentId]: metaDataValue,
            }));
          } else {
            setAllMetaData((prev) => ({
              ...prev,
              [assignmentId]: {},
            }));
          }
        },
        (error) => {
          console.error(
            `Firebase metadata listener error for ${assignmentId}:`,
            error
          );
        }
      );

      unsubscribes.push({ ref: metaDataRef, unsubscribe });
    });

    return () => {
      unsubscribes.forEach(({ ref: metaDataRef, unsubscribe }) => {
        off(metaDataRef, unsubscribe);
      });
    };
  }, [assignmentList]);

  useEffect(() => {
    const scrollToBottom = () => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollBottom =
          chatContainerRef.current.scrollHeight;
      }
    };

    // Scroll immediately
    scrollToBottom();

    // Keep scrolling to bottom every 100ms to ensure we're always at the bottom
    const interval = setInterval(scrollToBottom, 100);

    // Clean up interval after 1 second (10 attempts)
    const cleanup = setTimeout(() => {
      clearInterval(interval);
    }, 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(cleanup);
    };
  }, [messages]);

  const redux_selector = useSelector((state) => ({
    UserData: state.BrandUserDataReducer,
    Auth: state.BrandUserAuthReducer,
  }));

  const { UserData = {} } = redux_selector;
  const { brand_deep_data = {} } = UserData;
  const { org_deep_data = {} } = UserData;

  function getAssignmentBrandDetails() {
    var params = {};
    if (campaignId) {
      params.campaign_id = campaignId;
    }
    Core.getAssignmentUser(
      getAssignmentBrandDetailsSuccess,
      getAssignmentBrandDetailsFailed,
      setIsLoading,
      params
    );
  }

  function getAssignmentBrandDetailsSuccess(response_data) {
    setAssignmentList(response_data.assignment_list);

    if (assignmentId) {
      setIsMobile(false);
      const selectedAssignmentData = response_data.assignment_list.find(
        (assignment_deep_data) =>
          assignment_deep_data.assignment_data.assignment_id === assignmentId
      );

      if (selectedAssignmentData) {
        getInfluencerDetailPublic(
          selectedAssignmentData?.influencer_data?.influencer_id
        );
        setAssignmentDetail({
          assignment_status:
            selectedAssignmentData?.assignment_data?.assignment_status,
        });
        setInfluencerData({
          name: selectedAssignmentData?.brand_data?.name,
          org_id_id: selectedAssignmentData?.brand_data?.org_id,
          influencer_id: selectedAssignmentData?.influencer_data?.influencer_id,
          influencer_name: selectedAssignmentData?.influencer_data?.name,
          profile_picture:
            selectedAssignmentData?.brand_data?.image_id,
          influencer_profile_picture: selectedAssignmentData?.influencer_data?.profile_picture,
          assignment_id: selectedAssignmentData?.assignment_data?.assignment_id,
          brand_id: selectedAssignmentData?.brand_data?.brand_id,
        });
      }
    }
  }

  function getAssignmentBrandDetailsFailed(errorList) {
    console.error(errorList);
  }

  function getInfluencerDetailPublic(influencer_id) {
    const params = { influencer_id };
    Core.getInfluencerDetailPublic(
      getInfluencerDetailPublicSuccess,
      getInfluencerDetailPublicFailed,
      () => {},
      params
    );
  }

  function getInfluencerDetailPublicSuccess(response) {
    setInfluencerDetail(response.influencer_deep_data);
  }

  function getInfluencerDetailPublicFailed(errorList) {
    openSnackbar(errorList.map((err) => err.m).join(", "));
  }

  const handleKeyPress = (event) => {
    if (event && (event.key === "Enter" || event.key === "Return")) {
      if (event.shiftKey) {
        // Allow new line when Shift+Enter or Shift+Return is pressed
        return;
      } else {
        // Send message when Enter or Return is pressed without Shift
        event.preventDefault();
        postMessagesUserList();
      }
    }
  };

  function updateMetaData(assignmentId, force = false) {
    if (!assignmentId) {
      console.log("❌ No assignment ID provided to updateMetaData");
      return;
    }

    const now = Date.now();
    const lastCallTime = lastUpdateMetaDataCall.current[assignmentId] || 0;
    const timeSinceLastCall = now - lastCallTime;

    // Only enforce cooldown if not forced and not the first call
    if (!force && timeSinceLastCall < 2000) {
      // Reduced cooldown to 2 seconds
      return;
    }

    // Update the last call time before making the API call
    lastUpdateMetaDataCall.current[assignmentId] = now;

    const params = {
      assignment_id: assignmentId,
    };

    // Make the API call
    Core.updateMetaData(
      (response) => {
        console.log(`✅ Metadata API succeeded for ${assignmentId}`, response);
        // Update local state if needed based on response
      },
      (errorList) => {
        console.error("❌ Update metadata API failed:", errorList);
        // Reset the last call time on failure so we can retry
        lastUpdateMetaDataCall.current[assignmentId] = 0;
      },
      () => {},
      params
    );
  }

  function postMessagesUserList() {
    const params = {
      // message_text: newMessage,
      assignment_id: influencerData.assignment_id,
      is_focussed: 1,
      influencer_id: influencerData.influencer_id,
    };
    if (mediaId) {
      params.message_media_id = mediaId;
    }
    if (newMessage) {
      params.message_text = newMessage;
    }

    // Optimistically clear the input field and mediaId immediately
    const messageToSend = newMessage;
    inputRef.current.value = "";
    setNewMessage("");
    setMediaId(null);
    setSelectedFile(null); // Clear preview after sending

    Core.postMessagesUserList(
      postMessagesUserListSuccess,
      (errorList) => postMessagesUserListFailed(errorList, messageToSend),
      () => {},
      params
    );
  }

  function postMessagesUserListSuccess(response_data) {
    console.log("Message sent successfully:", response_data);
    // Firebase listener will handle the message update and trigger the scroll
  }

  function postMessagesUserListFailed(errorList) {
    toast.error(
      errorList.map((err) => err.m).join(", ") || "Failed to send message."
    );
    // Optionally: setNewMessage(originalMessage);
    // Optionally: inputRef.current.value = originalMessage;
  }

  function openGetContactDetails() {
    setContactModalIsOpen(true);
  }
  function closeGetContactDetails() {
    setContactModalIsOpen(false);
  }

  function handleContentApproval(contentId) {
    const params = {
      assignment_id: influencerData.assignment_id,
      content_id: contentId,
      is_approved: "true",
    };
    Core.postUserAssignmentReviewContent(
      (response) => {
        toast.success("Content approved successfully");
        setLoadingContentAction({});
      },
      (errorList) => {
        toast.error(
          errorList.map((err) => err.m).join(", ") ||
            "Failed to approve content"
        );
        setLoadingContentAction({});
      },
      (status) => setLoadingContentAction({ [contentId]: status }),
      params
    );
  }

  function handleContentRejection(contentId) {
    const params = {
      assignment_id: influencerData.assignment_id,
      content_id: contentId,
      comment: "Content rejected from chat",
      is_approved: "false",
    };
    Core.postUserAssignmentReviewContent(
      (response) => {
        toast.success("Content rejected successfully");
        setLoadingContentAction({});
      },
      (errorList) => {
        toast.error(
          errorList.map((err) => err.m).join(", ") || "Failed to reject content"
        );
        setLoadingContentAction({});
      },
      (status) => setLoadingContentAction({ [contentId]: status }),
      params
    );
  }

  function messageSideBar() {
    return (
      <div
        className="influencer_name_chat_container"
        style={{
          minWidth: 364,
          width: isMobile ? "100%" : 364,
          marginLeft: isMobile ? 0 : 20,
          marginRight: isMobile ? 0 : 20,
        }}
      >
        <div className="contract_message_list">
          {assignmentList &&
            assignmentList.map((item, index) => {
              const isActive =
                influencerData.assignment_id ==
                item.assignment_data?.assignment_id;
              const currentAssignmentId = item.assignment_data?.assignment_id;
              const currentMetaData = allMetaData[currentAssignmentId] || {};

              console.log(
                "currentMetaData for",
                currentAssignmentId,
                currentMetaData
              );

              return (
                <div
                  key={index}
                  onClick={() => {
                    if (isActive) return; // Prevent unnecessary reloads

                    // Clear messages immediately to prevent showing wrong messages
                    setMessages([]);
                    setMessagesLoader(true);

                    getInfluencerDetailPublic(
                      item.influencer_data.influencer_id
                    );
                    setIsMobile(false);
                    const selectedAssignmentId =
                      item.assignment_data?.assignment_id;
                    setInfluencerData({
                      name: item.brand_data.name, 
                      org_id: item.brand_data.org_id,
                      influencer_id: item.influencer_data.influencer_id,
                      influencer_name: item?.influencer_data?.name,
                      profile_picture: item.brand_data.image_id,
                      influencer_profile_picture: item.influencer_data.profile_picture,
                      assignment_id: selectedAssignmentId,
                      brand_id: item?.brand_data?.brand_id,
                    });
                    setAssignmentDetail({
                      assignment_status:
                        item?.assignment_data?.assignment_status,
                    });
                  }}
                  className={
                    isActive
                      ? "influencer_name_list_active"
                      : "influencer_name_list"
                  }
                >
                  <Image
                    source={
                      item.brand_data.image_id
                        ? Utils.generateBrandLogoUrl(
                            item.brand_data.org_id,
                            item.brand_data.image_id
                          )
                        : require("../../resources/images/user-copy.png")
                    }
                    fallBack={require("../../resources/images/user-copy.png")}
                    className="influencer_message_profile"
                  />
                  {item.assignment_data.unseen_brand === 1 && (
                    <div className="red-dot-pending-message"></div>
                  )}
                  <div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <span
                        style={{ flex: 1, color: "var(--gray-gray-500)" }}
                        className="button-text-14"
                      >
                        {item.campaign_data.name}
                      </span>
                      <span>
                        {currentMetaData &&
                          currentMetaData.influencer_unseen > 0 && (
                            <div
                              style={{
                                backgroundColor: "#007AFF",
                                borderRadius: "50%",
                                width: 10,
                                height: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            ></div>
                          )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "var(--gray-gray-300)",
                      }}
                    >
                      <CustomText
                        p
                        text={item.brand_data.name}
                        className="button1"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "var(--gray-gray-300)",
                      }}
                    > <Image
                    source={
                      item?.influencer_data?.profile_picture
                        ? Utils.generateInfluencerDpUrl(
                            item?.influencer_data?.influencer_id,
                            item?.influencer_data?.profile_picture
                          )
                        : require("../../resources/images/user-copy.png")
                    }
                    fallBack={require("../../resources/images/user-copy.png")}
                    className="influencer_message_profile_small"
                  />
                      <CustomText
                        p
                        text={item.influencer_data.name}
                        className="button1"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        justifyContent: "space-between",
                      }}
                    >
                      {currentMetaData && currentMetaData.last_message && (
                        <div
                          className="truncate-1-lines"
                          style={{
                            fontSize: 12,
                            color: "var(--gray-gray-100)",
                            marginTop: 4,
                          }}
                        >
                          {![
                            "SIGN_CONTRACT",
                            "UPLOAD_CONTENT",
                            "CONTENT_UPLOADED",
                            "UPLOAD_URL",
                            "PAYOUT_GENERATED",
                            "Media uploaded successfully",
                          ].includes(currentMetaData.last_message) && (
                            <div>{currentMetaData.last_message}</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  const handleContentUrlSubmit = (assignment_id,content_id) => {
        if (!url) {
          openSnackbar("Please enter a URL");
          return;
        }
        
        let params={
          assignment_id: assignment_id,
          influencer_id: influencerData?.influencer_id,
          content_url: url,
          content_id: content_id
        }
        
        Core.submitContentUrl(
          () => {
            // Success callback
            setUrl("");
            openSnackbar("Link Submitted");
          },
          (errorList) => {
            // Error callback
            openSnackbar(errorList.map((item) => item.m).join(", "));
          },
          ()=>{},
          params
        )
      };

  function messageChatScreen() {
    // Only render the chat if an influencer is selected (i.e., assignment_id is present)
    if (!influencerData.assignment_id) {
      return (
        <div className="message_chat_box_container">
          <div className="no-message-container">
            <Icon iconName={"messageFallBack"} width={100} height={105} />
            <div className="message-fall-back">
              <CustomText
                p
                text={"Select a Conversation"}
                fontSize={"font_size_2xl"}
                textColor={"text_color_primary"}
              />
              <CustomText
                p
                fontSize={"font_size_large"}
                text={"Click on a creator to view or start a chat."}
                textColor={"text_color_secondary"}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="message_chat_box_container">
        <>
          <div className="message_chat_box_header-container">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <div className="message_chat_box_header">
              <Image
                source={
                  influencerData.profile_picture
                    ? Utils.generateBrandLogoUrl(
                        influencerData.org_id,
                        influencerData.profile_picture
                      )
                    : require("../../resources/images/user-copy.png")
                }
                fallBack={require("../../resources/images/user-copy.png")}
                className="influencer_message_profile"
              />
              <CustomText p text={influencerData?.name} className="button2" />
              
            </div>
            <div>
              <div className="message_chat_box_header">
              <Image
                source={
                  influencerData.influencer_profile_picture
                    ? Utils.generateInfluencerDpUrl(
                        influencerData.influencer_id,
                        influencerData.influencer_profile_picture
                      )
                    : require("../../resources/images/user-copy.png")
                }
                fallBack={require("../../resources/images/user-copy.png")}
                className="influencer_message_profile"
              />
              <CustomText p text={influencerData?.influencer_name} className="button2" />
            </div>
            </div>
            </div>
            {assignmentDetail?.assignment_status !== "COMPLETED" && (
              <div
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                onClick={() => openGetContactDetails()}
                style={{ cursor: "pointer" }}
              >
                {/* <Icon iconName="contactCallIcon" /> */}
              </div>
            )}
            <div
              className="mobile-icon-close-icon"
              onClick={() => setIsMobile(true)}
            >
              <Icon iconName="CrossBtnIcon" />
            </div>
          </div>

          <div ref={chatContainerRef} className="message_box_container">
            {messageLoader ? (
              <div className="loader-mid">
                <Loader />
              </div>
            ) : (
              <>
                {messages.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      flexGrow: 1,
                      height: "100%",
                    }}
                  >
                    <Icon
                      iconName={"messageFallBack"}
                      width={100}
                      height={105}
                    />
                    <div className="flex-column">
                      <div style={{ marginBottom: 10, marginTop: 5 }}>
                        <CustomText
                          p
                          fontSize={"font_size_large"}
                          text={"No Messages"}
                          textColor={"text_color_primary"}
                        />
                      </div>
                      <CustomText
                        p
                        fontSize={"font_size_large"}
                        text={"Start a conversation with influencer"}
                        textColor={"text_color_secondary"}
                      />
                    </div>
                  </div>
                ) : (
                  messages.map((item, index) => {
                    // Check if this is a contract signing completion message
                    const isContractSigned =
                      item.action_type === "SIGN_CONTRACT" &&
                      item.action_status === "COMPLETED";
                    const hasContentInReview =
                      item.action_type === "CONTENT_UPLOADED" &&
                      item.action_status === "IN_REVIEW";
                    const hasContentComplete =
                      item.action_status == "CONTENT_APPROVED";
                    const hasUrlUploaded =
                      item.action_type == "UPLOAD_URL" &&
                      item.action_status == "COMPLETED";

                    const contentRejected =
                      item.action_type == "CONTENT_REJECTED";

                    // Render media if present - check both message_media_id and media_id
                    let mediaElem = null;
                    const mediaIdToUse = item.message_media_id;

                    if (mediaIdToUse) {
                      // Use brand_id for media url
                      const brandId = influencerData?.brand_id;
                      const mediaUrl = Utils.generateCampaignSampleUrl(
                        brandId,
                        mediaIdToUse
                      );
                      const ext = mediaUrl?.split(".").pop().toLowerCase();
                      if (
                        ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(
                          ext
                        )
                      ) {
                        mediaElem = (
                          <img
                            src={mediaUrl}
                            alt="media"
                            style={{
                              maxWidth: 300,
                              maxHeight: 200,
                              marginTop: 8,
                              borderRadius: 8,
                            }}
                          />
                        );
                      } else if (["mp4", "webm", "ogg", "mov"].includes(ext)) {
                        mediaElem = (
                          <video
                            src={mediaUrl}
                            controls
                            style={{
                              maxWidth: 300,
                              maxHeight: 200,
                              marginTop: 8,
                              borderRadius: 8,
                            }}
                          />
                        );
                      } else {
                        mediaElem = (
                          <a
                            href={mediaUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download media
                          </a>
                        );
                      }
                    }

                    // For rejected content, set contentMediaElem if content_media_id exists
                    let contentMediaElem = null;
                    if (contentRejected) {
                      const contentMediaId = item.content_media_id;
                      if (contentMediaId) {
                        const contentUrl = Utils.constructContentMediaUrl(
                          item?.assignment_id,
                          contentMediaId
                        );
                        const ext = contentUrl.split(".").pop().toLowerCase();
                        if (
                          ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(
                            ext
                          )
                        ) {
                          contentMediaElem = (
                            <img
                              src={contentUrl}
                              alt="content media"
                              style={{
                                width: "100%",
                                minWidth: 200,
                                maxWidth: 300,
                                maxHeight: 300,
                                marginTop: 12,
                                borderRadius: 8,
                                cursor: "pointer",
                                objectFit: "cover",
                              }}
                              onClick={() => window.open(contentUrl, "_blank")}
                            />
                          );
                        } else if (
                          ["mp4", "webm", "ogg", "mov"].includes(ext)
                        ) {
                          contentMediaElem = (
                            <video
                              src={contentUrl}
                              controls
                              style={{
                                width: "100%",
                                minWidth: 200,
                                maxWidth: 300,
                                maxHeight: 300,
                                marginTop: 12,
                                borderRadius: 8,
                              }}
                            />
                          );
                        }
                      }
                    }

                    // Determine message text to display
                    let displayMessageText = item.message_text;
                    let displayContractMessage;
                    let displayInReviewContent;
                    let displayApprovedContent;
                    let displayURLMessage;
                    let contentRejectionMessage;
                    if (contentRejected) {
                      contentRejectionMessage = `Content has been rejected by brand influencer will upload new content soon`;
                    }
                    if (isContractSigned) {
                      displayContractMessage = `🎉 ${influencerData?.name} has successfully signed the contract`;
                    }
                    if (hasContentInReview) {
                      displayInReviewContent = `Your content is in review pls wait to be reviewed by brand`;
                      // Render content media if available
                      const contentMediaId = item.content_media_id;
                      if (contentMediaId) {
                        const contentUrl = Utils.constructContentMediaUrl(
                          item?.assignment_id,
                          contentMediaId
                        );
                        const ext = contentUrl.split(".").pop().toLowerCase();
                        if (
                          ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(
                            ext
                          )
                        ) {
                          contentMediaElem = (
                            <img
                              src={contentUrl}
                              alt="content media"
                              style={{
                                width: "100%",
                                minWidth: 200,
                                maxWidth: 300,
                                maxHeight: 300,
                                marginTop: 12,
                                borderRadius: 8,
                                cursor: "pointer",
                                objectFit: "cover",
                              }}
                              onClick={() => window.open(contentUrl, "_blank")}
                            />
                          );
                        } else if (
                          ["mp4", "webm", "ogg", "mov"].includes(ext)
                        ) {
                          contentMediaElem = (
                            <video
                              src={contentUrl}
                              controls
                              style={{
                                width: "100%",
                                minWidth: 200,
                                maxWidth: 300,
                                maxHeight: 300,
                                marginTop: 12,
                                borderRadius: 8,
                              }}
                            />
                          );
                        }
                      }
                    }
                    if (hasContentComplete) {
                      displayApprovedContent = `Content has been approved by brand.`;
                      // Render content media if available
                      const contentMediaId = item.content_media_id;
                      if (contentMediaId) {
                        const contentUrl = Utils.constructContentMediaUrl(
                          item?.assignment_id,
                          contentMediaId
                        );
                        const ext = contentUrl.split(".").pop().toLowerCase();
                        if (
                          ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(
                            ext
                          )
                        ) {
                          contentMediaElem = (
                            <img
                              src={contentUrl}
                              alt="content media"
                              style={{
                                width: "100%",
                                minWidth: 200,
                                maxWidth: 300,
                                maxHeight: 300,
                                marginTop: 12,
                                borderRadius: 8,
                                cursor: "pointer",
                                objectFit: "cover",
                              }}
                              onClick={() => window.open(contentUrl, "_blank")}
                            />
                          );
                        } else if (
                          ["mp4", "webm", "ogg", "mov"].includes(ext)
                        ) {
                          contentMediaElem = (
                            <video
                              src={contentUrl}
                              controls
                              style={{
                                width: "100%",
                                minWidth: 200,
                                maxWidth: 300,
                                maxHeight: 300,
                                marginTop: 12,
                                borderRadius: 8,
                              }}
                            />
                          );
                        }
                      }
                    }
                    if (hasUrlUploaded) {
                      displayURLMessage = (
                        <span
                          style={{
                            position: "relative",
                            display: "inline-block",
                            cursor: "pointer",
                          }}
                        >
                          Content URL has been submitted
                          <span
                            style={{
                              position: "absolute",
                              bottom: "100%",
                              left: "50%",
                              transform: "translateX(-50%)",
                              backgroundColor: "#333",
                              color: "#fff",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              marginBottom: "5px",
                              display: "none",
                              zIndex: 1,
                            }}
                            className="url-tooltip"
                          >
                            Click here to see URL
                          </span>
                          <style>{`.url-tooltip {
                              display: none !important;
                            }
                            .url-tooltip-parent:hover .url-tooltip {
                              display: block !important;
                            }`}</style>
                        </span>
                      );
                    }

                    // Determine sender type - contract signed messages should show as influencer messages
                    const effectiveSenderType = isContractSigned
                      ? "influencer"
                      : item.sender_type;

                    return (
                      <div key={item.message_id || index}>
                        <div
                          className={
                            effectiveSenderType === "influencer"
                              ? "message_influencer"
                              : "message_user"
                          }
                        >
                          {displayMessageText && (
                            <CustomText
                              p
                              text={displayMessageText}
                              className={
                                effectiveSenderType === "influencer"
                                  ? "message_influencer_text"
                                  : "message_user_text"
                              }
                            />
                          )}
                          {mediaElem}
                          {displayMessageText && (
                            <div style={{ marginTop: 5 }}>
                              <p
                                style={{
                                  fontSize: 10,
                                  color: "var(--gray-gray-100)",
                                }}
                              >
                                {"At " +
                                  Utils.convertUnixToTime(item.created_at)}
                              </p>
                            </div>
                          )}
                        </div>
                        {displayInReviewContent && (
                          <div
                            className="message_influencer_text font-700"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                              justifyContent: "center",
                              // alignItems: "flex-end",
                              padding: "8px 12px",
                              borderRadius: "16px 16px 16px 4px",
                              width: "fit-content",
                              marginBottom:10
                            }}
                          >
                            <div>{displayInReviewContent}</div>
                            <div style={{ maxWidth: "100%" }}>
                              {contentMediaElem}
                            </div>
                            {/* {hasContentInReview && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: 10,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                  marginTop: 8,
                                }}
                              >
                                <div style={{ flex: 1 }}>
                                  <PrimaryCta
                                    invert
                                    height={"32px"}
                                    text={"Reject"}
                                    padding={"6px 12px"}
                                    onClick={() =>
                                      handleContentRejection(item.content_id)
                                    }
                                  />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <PrimaryCta
                                    fullWidth100
                                    height={"32px"}
                                    text={"Accept"}
                                    onClick={() =>
                                      handleContentApproval(item.content_id)
                                    }
                                  />
                                </div>
                              </div>
                            )} */}
                          </div>
                        )}
                        {displayApprovedContent && (
                          <div
                            className="message_influencer_text font-700"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                              justifyContent: "center",
                              alignItems: "flex-start",
                              padding: "8px 12px",
                              borderRadius: "16px 16px 16px 4px",
                              width: "fit-content",
                              maxWidth: "390px",
                            }}
                          >
                            <div>{displayApprovedContent}</div>
                            <div style={{ maxWidth: "100%" }}>
                              {contentMediaElem}
                            </div>
                            {/* {item?.action_status !== "COMPLETED" && <div style={{display:"flex",gap:8,flexDirection:"column",width:"100%"}}>
                              <div style={{flex: 1}}> 
                              <CustomTextInput
                                value={url}
                                onChange={(e) => setUrl(e.target.value)}
                                placeholder="Enter content URL"
                                fullWidth
                              />
                              </div>
                              <div style={{flex: 1}}>
                              <PrimaryCta
                                fullWidth100
                                height={"32px"}
                                text={"Submit URL"}
                                onClick={() =>
                                  handleContentUrlSubmit(
                                    item.assignment_id,
                                    item.content_id
                                  )
                                }
                                style={{ marginTop: 8 }}
                              />
                              </div>
                            </div>} */}
                          </div>
                        )}
                        {displayContractMessage && (
                          <div
                            style={{
                              backgroundColor: "var(--bg-white-color)",
                              padding: "8px 12px",
                              borderRadius: "16px 16px 16px 4px",
                              width: "fit-content",
                              marginBottom:10
                            }}
                            className="font-700"
                          >
                            {displayContractMessage}
                          </div>
                        )}
                        {displayURLMessage && (
                          <div
                            className="message_influencer_text font-700"
                            onClick={() =>
                              navigate(`/contracts/${item.assignment_id}`)
                            }
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                              justifyContent: "center",
                              alignItems: "flex-start",
                              padding: "8px 12px",
                              borderRadius: "16px 16px 16px 4px",
                              width: "fit-content",
                            }}
                          >
                            <div>{displayURLMessage}</div>
                          </div>
                        )}
                        {contentRejectionMessage && (
                          <div
                            style={{
                              backgroundColor: "var(--bg-white-color)",
                              padding: "8px 12px",
                              borderRadius: "16px 16px 16px 4px",
                              width: "fit-content",
                              maxWidth: "390px",
                            }}
                            className="font-700"
                          >
                            <div>{contentRejectionMessage}</div>
                            <div style={{ maxWidth: "100%" }}>
                              {contentMediaElem}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </>
            )}
          </div>

          <div
            className="message_send_input_container"
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* File Picker (hidden input) */}
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept="image/*,video/*"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {/* File Picker Button */}
            <button
              type="button"
              className="media-upload-btn"
              onClick={openFilePicker}
              disabled={uploading}
              style={{
                display: "flex",
                marginLeft: 4,
                cursor: uploading ? "not-allowed" : "pointer",
                border: "none",
                background: "transparent",
                fontSize: "20px",
              }}
            >
              {uploading ? "⏳" : <Icon iconName="attachmentIcon" />}
            </button>
            {/* Show selected media preview */}
            {selectedFile && (
              <div
                style={{
                  position: "relative",
                  marginRight: 8,
                  padding: 4,
                  background: "#f0f0f0",
                  borderRadius: 4,
                  fontSize: 12,
                  display: "flex",
                  alignItems: "center",
                }}
                onMouseEnter={() => setShowPreviewLarge(true)}
                onMouseLeave={() => setShowPreviewLarge(false)}
              >
                {selectedFile.type.startsWith("image/") ? (
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="preview"
                    style={{
                      width: 40,
                      height: 40,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                ) : selectedFile.type.startsWith("video/") ? (
                  <video
                    src={URL.createObjectURL(selectedFile)}
                    style={{
                      width: 40,
                      height: 40,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                ) : (
                  <span>{selectedFile.name}</span>
                )}
                {/* Remove button */}
                <button
                  type="button"
                  onClick={removeSelectedFile}
                  style={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    border: "none",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  <Icon iconName="crossIconSmall" width={12} height={12} />
                </button>
                {/* Large preview on hover */}
                {showPreviewLarge && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: 50,
                      left: 0,
                      zIndex: 1000,
                      background: "white",
                      border: "2px solid #ddd",
                      borderRadius: 8,
                      padding: 8,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                  >
                    {selectedFile.type.startsWith("image/") ? (
                      <img
                        src={URL.createObjectURL(selectedFile)}
                        alt="preview large"
                        style={{
                          maxWidth: 300,
                          maxHeight: 300,
                          objectFit: "contain",
                          borderRadius: 4,
                        }}
                      />
                    ) : selectedFile.type.startsWith("video/") ? (
                      <video
                        src={URL.createObjectURL(selectedFile)}
                        controls
                        style={{
                          maxWidth: 300,
                          maxHeight: 300,
                          borderRadius: 4,
                        }}
                      />
                    ) : null}
                  </div>
                )}
              </div>
            )}
            <textarea
              ref={inputRef}
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              className="message_send_input"
              placeholder="Type your message here... (Shift+Enter for new line)"
              onKeyPress={handleKeyPress}
              disabled={!influencerData.assignment_id}
              style={{ 
                flex: 1,
                resize: 'none',
                minHeight: '20px',
                maxHeight: '120px',
                overflowY: 'auto'
              }}
              rows={1}
            />
            <div
              className="send_button_message"
              onClick={postMessagesUserList}
              style={{
                cursor: newMessage.trim() || mediaId ? "pointer" : "default",
              }}
            >
              {!(newMessage.trim() || mediaId) ? (
                <Icon iconName={"sendButtonNonActive"} />
              ) : (
                <Icon iconName={"sendButtonActive"} />
              )}
            </div>
          </div>
        </>
      </div>
    );
  }

  return (
    <div className="dashboard-container background-color-primary">
      <SideMenu />
      <div className="main-screen">
        <Header />
        <div className="internal-chat-page-containe page-container-campaignList">
          {isLoading ? (
            <div className="loader-mid">
              <Loader />
            </div>
          ) : assignmentList.length === 0 ? (
            <div className="no-message-container">
              <Icon iconName={"messageFallBack"} width={100} height={105} />
              <div className="message-fall-back">
                <CustomText
                  p
                  text={"No Messages"}
                  fontSize={"font_size_2xl"}
                  textColor={"text_color_primary"}
                />
                <CustomText
                  p
                  fontSize={"font_size_large"}
                  text={"Start a conversation with creator"}
                  textColor={"text_color_secondary"}
                />
              </div>
            </div>
          ) : (
            <>
              <div
                style={{ height: window.innerHeight - 150 }}
                className="message-and-siderbar-container"
              >
                {/* Desktop View */}
                {messageSideBar()}
                {messageChatScreen()}
              </div>
              <div className="message-and-siderbar-mobile-container">
                {/* Mobile View */}
                {isMobile ? messageSideBar() : messageChatScreen()}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MessagesScreen;
